import React, { useEffect } from 'react'
import { NextPage } from 'next'
import WomansCategory from 'src/components/Category/MainCategory/WomenCategory'
import WomenPageModal from 'src/components/Category/MainCategory/WomenCategory/WomenPageModal'
import { useSelector } from 'react-redux'

const WomenCategory: NextPage = () => {
  const manageApplianceCategoryModal = useSelector((state: any) => state?.manageApplianceCategoryModal?.data)

  useEffect(() => {
    if (manageApplianceCategoryModal?.isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [manageApplianceCategoryModal])

  return (
    <React.Fragment>
      <WomansCategory />
      <WomenPageModal />
    </React.Fragment>
  )
}

export default WomenCategory
